<template>
  <div id="footer">
    <div class="uk-section uk-visible@s">
      <!-- DESKTOP -->
      <div class="uk-visible@s uk-grid uk-grid-large uk-container" uk-grid>
        <div class="uk-width-1-3@s">
          <p class="uk-text-bold uk-text-large">ROOMI</p>
          <p class="uk-text-light font-description">Retail company in Indonesia specializing in the sale of electronic goods and home appliances. A wide range of smart home products, including Smart LEDs, Smart Security Cameras, LED TVs, and Smart TVs.</p>
          <div class="uk-flex">
            <a target="_blank" href="https://www.facebook.com/roomismarthome" uk-icon="icon: facebook; ratio: 0.9;" class="uk-icon-button" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
            <a target="_blank" href="https://www.instagram.com/roomismarthome/" uk-icon="icon: instagram; ratio: 0.9;" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
            <a target="_blank" href="https://www.tiktok.com/@roomiindonesia" uk-icon="icon: tiktok; ratio: 0.9" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
            <a target="_blank" href="https://www.youtube.com/@RoomiIndonesia" uk-icon="icon: youtube; ratio: 0.9" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
          </div>
        </div>
        <div class="uk-width-2-3@s">
          <div class="uk-grid uk-grid-large " uk-grid>
            <div>
              <p class="uk-text-bold uk-text-large">Store Info</p>
              <div class="uk-flex uk-flex-column">
                <!-- <button @click="goTo('collections')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Collections</button> -->
                 <button @click="goTo('store')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Offline Store</button>
                <button @click="goTo('about')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">About</button>
                <button @click="goTo('support')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Contact</button>
                <button @click="goTo('blog')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Blog</button>
              </div>
            </div>
            <!-- <div>
              <p class="uk-text-bold uk-text-large">Contacts</p>
              <div class="uk-flex uk-flex-column">
                <button class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom uk-text-lowercase">Roomismarthome@gmail.com</button>
                <button class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom uk-text-lowercase">info@roomi.co.id</button>
              </div>
            </div> -->
            <div>
              <p class="uk-text-bold uk-text-large">Location</p>
              <div class="uk-flex uk-flex-column">
                <p class="uk-margin-remove">IDD PIK2 Erajaya Digital Complex</p>
                <p class="uk-margin-remove">Jl. Rasuna Said No.16A, Salembaran, Kec. Kosambi,</p>
                <p class="uk-margin-remove">Kabupaten Tangerang, Banten 15214</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MOBILE -->
       <!-- <div class="uk-hidden@s  uk-margin-left uk-margin-right">
        <div class="uk-grid " uk-grid>
          <div class="uk-width-1-3@s">
            <img class="" width="150" :src="require('../assets/roomi-logo-grey.png')" alt="TV Image">
            <p class="uk-text-light font-description">Retail company in Indonesia specializing in the sale of electronic goods and home appliances. A wide range of smart home products, including Smart LEDs, Smart Security Cameras, LED TVs, and Smart TVs.</p>
            <div class="uk-flex">
              <a target="_blank" href="https://www.facebook.com/roomismarthome" uk-icon="icon: facebook; ratio: 0.9;" class="uk-icon-button" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
              <a target="_blank" href="https://www.instagram.com/roomismarthome/" uk-icon="icon: instagram; ratio: 0.9;" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
              <a target="_blank" href="https://www.tiktok.com/@roomiindonesia" uk-icon="icon: tiktok; ratio: 0.9" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
            </div>
          </div>
          <div class="uk-width-2-3@s">
            <div class="uk-grid uk-grid-medium" uk-grid>
              <div>
                <p class="uk-text-bold uk-text-large">Store Info</p>
                <div class="uk-flex uk-flex-column">
                   <button @click="goTo('store')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Offline Store</button>
                  <button @click="goTo('about')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">About</button>
                  <button @click="goTo('support')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Contact</button>
                  <button @click="goTo('blog')" class="uk-button uk-button-link uk-text-left font-description uk-margin-small-bottom">Blog</button>
                </div>
              </div>
              <div>
                <p class="uk-text-bold uk-text-large">Location</p>
                <div class="uk-flex uk-flex-column">
                  <p class="uk-margin-remove">IDD PIK2 Erajaya Digital Complex, Jl. Rasuna Said No.16A, Salembaran, Kec. Kosambi, Kabupaten Tangerang, Banten 15214</p>
                </div>
              </div>
            </div>
          </div>
        </div>
       </div> -->
    </div>

    <!--================================== MOBILE SECTION ========================= -->
    <div class="uk-margin-large-bottom">
      <div class="uk-text-center">
        <img class="" width="150" :src="require('../assets/roomi-logo-grey.png')" alt="TV Image">
      </div>
      <div class="uk-container uk-margin-small-top">
        <p class="uk-text-muted uk-margin-small-bottom">Kunjungi Media Sosial Kami</p>
        <div class="uk-flex">
          <a target="_blank" href="https://www.facebook.com/roomismarthome" uk-icon="icon: facebook; ratio: 0.9;" class="uk-icon-button" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
          <a target="_blank" href="https://www.instagram.com/roomismarthome/" uk-icon="icon: instagram; ratio: 0.9;" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
          <a target="_blank" href="https://www.tiktok.com/@roomiindonesia" uk-icon="icon: tiktok; ratio: 0.9" class="uk-icon-button uk-margin-small-left" style="color: #777; background-color: transparent; width: 30px; height: 30px;"></a>
        </div>
        <div class="uk-flex uk-margin-top uk-text-muted">
          <p @click="goTo('store')" class="uk-margin-medium-right uk-text-left uk-margin-remove-bottom">Kebijakan Privasi</p>
          <p @click="goTo('store')" class="uk-padding-right uk-text-left uk-margin-remove">Syarat dan Ketentuan</p>
        </div>
        <p class="uk-text-muted">Hak Cipta © 2024 ROOMI . Hak cipta dilindungi Undang-undang.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
      return {
          searchInput: false,
          logoImage: require('../assets/ROOMI_LOGO-03.png'),
          keyword: '',
          reviews: [],
          apiKey: 'AIzaSyC7yoXfWBL2zGxs384ajOsBOVTFTLgEVYw', // Replace with your Google Places API key
          placeId: 'ChIJcV-j6cL5aS4RiewxHdWEYPo', //
      }
  },
  computed: {
      getTahun: function () {
          let date = new Date();
          return date.getFullYear()
      }
  },
  methods: {
      searchForm: function () {
          if (this.searchInput) {
              this.searchInput = false
          } else {
              this.searchInput = true
          }
      },
      submitSearch() {
          if (this.$route.name == 'SearchPage') {
              const keyword = this.$route.query.keyword
              if (keyword != this.keyword) {
                  this.$router.replace({query: {keyword: this.keyword}})
              }
              this.$root.$emit('SearchPage')
              this.$root.$emit('changeKeywordNavigation')
          } else {
              this.$router.push('/search?keyword=' + this.keyword)
          }
      },
      changeKeyword() {
          if (this.$route.name == 'SearchPage') {
              const keyword = this.$route.query.keyword
              if(keyword) {
                  this.keyword = keyword
              } else {
                 this.keyword = ''
              }
          }
      },
      goTo(url){
        this.$router.push({ path: `/${url}` });
      },
      async fetchReviews() {
        const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
        const apiUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${this.placeId}&fields=reviews&key=${this.apiKey}`;
        try {
          const response = await fetch(proxyUrl + apiUrl);
          const data = await response.json();
          if (data.result && data.result.reviews) {
            this.reviews = data.result.reviews;
          } else {
            console.error('No reviews found or error occurred.');
          }
        } catch (error) {
          console.error('Error fetching reviews:', error);
        }
    },
  },
  mounted() {
    //this.fetchReviews();
      if (this.$route.name == 'SearchPage') {
          const keyword = this.$route.query.keyword
          if(keyword) {
              this.keyword = keyword
              this.searchInput = true
          } else {
              this.$router.push('/store')
          }
      }
      this.$root.$on('changeKeywordFooter', () => {
          this.changeKeyword()
      })
  }
}
</script>


<style scoped>
#footerTop {
  border-bottom: 1px solid rgb(255, 255, 255);
  padding-bottom: 15px;
}

#footer span {
  font-size: 12px;
  letter-spacing: 1px;
  color: rgb(255, 255, 255);
  font-weight: lighter;
}

.footerRight ul li a {
  font-size: 12px;
  color: #FFF !important;
  font-weight: 600;
  line-height: 25px;
}

#footerBottom {
  margin-top: 10px;
}

ul.sitemap {
  width: 100%;
}

ul.sitemap li {
  padding-left: 0;
  margin: 0 auto 0 0 !important;
  display: inline-flex;
  flex-wrap: wrap;
}

ul.sitemap li:nth-child(1) {
  margin-right: auto !important;
  flex: auto;
}

ul.sitemap li ul {
  padding-left: 0;
}

ul.sitemap li:nth-child(1) ul li a {
  font-size: 12px !important;
  text-transform: capitalize;
}

ul.sitemap li:nth-child(1) ul li a::after {
  content: "\02D7";
  padding-right: 2px;
}

ul.sitemap li:nth-child(1) ul li:last-child a::after {
  content: "";
}

#subscribe-form {
  border: 1px solid rgb(109, 110, 112);
  border-radius: 5px;
}

#subscribe-form input[type="text"] {
  border: unset;
  background-color: transparent;
  margin-left: 10px;
  color: rgb(255, 255, 255);
}

#subscribe-form input[type="text"]:focus {
  outline: unset;
}

#subscribe-form button {
  background-color: rgb(109, 110, 112);
  outline: unset;
  border: unset;
  color: rgb(255, 255, 255);
  font-size: 12px;
  border-radius: 10px;
  float: right;
  min-height: 20px;
  max-height: 20px;
  margin: 2px 8px;
}

@media screen and (max-width: 639px) {
  .footerRight {
      float: none !important;
      margin-bottom: 10px !important;
  }
}

/* SECTION TWO */
@media screen and (max-width: 640px) {
#footer .uk-container {
  padding: 0px 20px !important;
}
.maps-footer {
  width: 100% !important;
}
}
</style>